/*
t('service-fees:title.crane_charges')
t('service-fees:title.assembly_costs')
t('service-fees:title.incidental_expenses')
t('service-fees:title.cleaning_costs')
t('service-fees:title.return_inspection')
t('service-fees:title.preparation_costs')
t('service-fees:title.service_charges')
t('service-fees:title.protective_equipment')
 */
import React, { FC } from 'react';
import { useTranslation } from 'next-i18next';
import { readablePrice } from './readable-price';

export const ServiceFeeTitle: FC<{feeType: string}> = ({ feeType }) => {
  const [t] = useTranslation(['service-fees']);

  return (
    <>{t(`service-fees:title.${feeType}`)}</>
  );
};

export const mapServiceFees = (serviceFees: { key: string; value: number }[]) => {
  return serviceFees.map((fee) => ({
    key: fee.key,
    title: <ServiceFeeTitle feeType={fee.key} />,
    value: readablePrice(fee.value),
  }));
}